import CartoDBClass, * as CartoDBModule from './../../node_modules/ol/source/CartoDB.js';

class CartoDB extends CartoDBClass {
    constructor(options = {}) {
        options = options || {}
        super(options);
    }
}

// Copy all named exports as static methods
for (const key in CartoDBModule) {
    if (key !== "default") {
        CartoDB[key] = CartoDBModule[key];
    }
}

export default CartoDB;

// Re-export ALL named exports from OL
export * from './../../node_modules/ol/source/CartoDB.js';